import { Component, OnInit } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { ActivatedRoute, Router } from "@angular/router";
import Swal from "sweetalert2";
import { DatosFacturacionService } from "../../shared/datos-facturacion.service";
import { CFDI } from "../../entities/cdfi";
import { RFiscal } from "../../entities/regimenFiscal";
import { forkJoin } from 'rxjs';
import { tap } from 'rxjs/operators'; // Importación de tap
import { response } from "express";
import { randomFillSync } from "crypto";
import { DireccionesService } from "../../pages/account/direcciones/services/direcciones.service";
import { Direcciones } from "../../entities/Direcciones";
import { AuthServiceService } from "../account/login/services/auth-service.service";


@Component({
  selector: 'app-registro-datos-facturacion',
  templateUrl: './registro-datos-facturacion.component.html',
  styleUrls: ['./registro-datos-facturacion.component.scss']
})
export class RegistroDatosFacturacionComponent {
  public idDatoFactura: number;
  public facturacionForm: FormGroup;
  public listaCfdi: CFDI[];
  public listaRegimenFiscal: RFiscal[];
  public title = 'Registrar'
  public listaDirecciones: Direcciones[] = [];
  public showInfoDirec: boolean = false;
  public modalSwitch: boolean = false;

  constructor(
    private datosFactService: DatosFacturacionService,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private direccionesService: DireccionesService,
    private authService:AuthServiceService,
  ) { }

  ngOnInit() {  
    this.initForm();
    Swal.fire({
      text: "Cargando datos de facturación",
      allowOutsideClick: false,
      showConfirmButton: false,
      onBeforeOpen: () => {
        Swal.showLoading();
      },
      customClass: {
        container: "custom-swal-height",
      },
    });

    this.route.params.subscribe((param) => {
      this.idDatoFactura = param["id"];
    });

    this.obtenerCFDIyRF().subscribe(() => {
      if (this.idDatoFactura) {
        this.title = 'Editar';
        this.obtenerDatos(this.idDatoFactura);
      } else {
        Swal.close();
      }
    });
    this.getDireccion();

    this.direccionesService.$modal.subscribe((value) => {
      this.modalSwitch = value.statusModal;
      if (value.reloadPage) {
        window.location.reload();
      }
    });
    
  }

  addDireccion() {
        this.modalSwitch = true;
  }

  obtenerDatos(id: number) {
    this.datosFactService.obtenerDatosById(id).subscribe(
      (response) => {
        // Aquí, las listas ya están cargadas, por lo que podemos usarlas
        this.facturacionForm.patchValue({
          nombre: response.nombre,
          rfc: response.rfc,
          cp: response.cp,
          correo: response.correo,
          regimenFiscal: this.listaRegimenFiscal.find(rf => rf.valor == response.regimenFiscal),
          usoCfdi: this.listaCfdi.find(cfdi => cfdi.usoCFDI === response.usoCfdi)
        });

        Swal.close();
      },
      (error) => {
        console.error('Error fetching data', error);
        Swal.close();
      }
    );
  }


  getDireccion() {
    this.direccionesService
      .obtenerMensajes()
      .subscribe((result: Direcciones[]) => {
        this.listaDirecciones = result;
        if(this.listaDirecciones.length > 0) {
          this.showInfoDirec = false;
        } else {
          this.showInfoDirec = true;
        }
      });
  }

  obtenerCFDIyRF() {
    return forkJoin({
      cfdi: this.datosFactService.listarCFDI(),
      regimenFiscal: this.datosFactService.listarRegimenFiscal()
    }).pipe(
      tap(({ cfdi, regimenFiscal }) => {
        this.listaCfdi = cfdi;
        this.listaRegimenFiscal = regimenFiscal;
      })
    );
  }


  initForm() {
    this.facturacionForm = this.fb.group({
      id: '',
      rfc: new FormControl("", [
        Validators.required,
        Validators.pattern(/^(?=.*[a-zA-Z])(?=.*\d).+$/),
        Validators.maxLength(16),
      ]),
      // referencia: new FormControl("", [Validators.required]),
      nombre: new FormControl("", [Validators.required]),
      cp: new FormControl(""),
      regimenFiscal: new FormControl("", [Validators.required]),
      usoCfdi: new FormControl("", [Validators.required]),
      idDireccion: new FormControl(""),
      direccion: new FormControl("", [Validators.required]),
      correo: new FormControl("", [Validators.required, Validators.email])
    });
  }

  soloLetrasNumerosExt(event: any): void {
    const input = event.target as HTMLInputElement;
    const soloLetrasNumeros = input.value.replace(/[^a-zA-Z0-9]/g, "");
    this.facturacionForm.patchValue({ rfc: soloLetrasNumeros });
  }
  soloLetrasNumerosEspacios(event: any): void {
    const input = event.target as HTMLInputElement;
    const soloLetrasNumeros = input.value.replace(/[^a-zA-Z0-9\s]/g, ""); // Incluye \s para espacios
    this.facturacionForm.patchValue({ rfc: soloLetrasNumeros });
  }

  soloNumerosDomFisc(event: any): void {
    const input = event.target as HTMLInputElement;
    const soloNumeros = input.value.replace(/[^0-9]/g, "");
    this.facturacionForm.patchValue({ cp: soloNumeros });
  }

  soloNumerosRegimenFiscal(event: any): void {
    const input = event.target as HTMLInputElement;
    const soloNumeros = input.value.replace(/[^0-9]/g, "");
    this.facturacionForm.patchValue({ regimenFiscal: soloNumeros });
  }



  changeCdfi() {
    //console.log('aca');
  }

  changeRf() {
    //console.log('aca');
  }

  guardar() {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Para un desplazamiento suave
    });
    if (this.facturacionForm.invalid) {
      this.facturacionForm.markAllAsTouched();
      this.toastr.error("Debes completar todos los campos correctamente");
    } else {
      const control = this.facturacionForm.controls;
      let data = {
        nombre: control.nombre.value,
        rfc: control.rfc.value,
        correo: control.correo.value,
        cp: control.direccion.value.codigoPostal,
        regimenFiscal: control.regimenFiscal.value.valor,
        usoCfdi: control.usoCfdi.value.usoCFDI,
        idDireccion: control.direccion.value.id,
      };
      
      if (this.idDatoFactura) {
        data['id'] = this.idDatoFactura;
        this.datosFactService
          .actualizarDatos(data)
          .subscribe(
            (success) => {
              this.volver();
              Swal.fire({
                title: "¡Operación exitosa!",
                html: `¡Se han modificado de manera exitosa los datos!`,
                icon: "success",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Confirmar",
              });
            },
            (error) => {
              Swal.fire({
                title: "¡Ops!",
                text: `¡Error al intentar actualizar los datos!`,
                icon: "warning",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Confirmar",
                onClose: () => {
                  this.router.navigateByUrl('pages/datos-facturacion')
                }
              });
            }
          );

      }
       else {
        this.datosFactService.guardarDatos(data).subscribe(
          (result: any) => {
            Swal.fire({
              title: "Datos Guardados!",
              text: "Los datos han sido guardados con éxito.",
              icon: "success",
              confirmButtonText: 'Aceptar',
              onClose: () => {
                this.router.navigateByUrl('pages/datos-facturacion')
              }
            });
          },
          (err) => {
            Swal.fire({
              title: "¡Ops!",
              text: err.error,
              icon: "error",
              confirmButtonText: "Cerrar"
            });
          }
        );
      }
    }
  }

  compareCfdi(c1: CFDI, c2: CFDI): boolean {
    return c1 && c2 ? c1.id === c2.id : c1 === c2;
  }

  compareRf(rf1: CFDI, rf2: CFDI): boolean {
    return rf1 && rf2 ? rf1.id === rf2.id : rf1 === rf2;
  }

  volver() {
    this.router.navigate(["/pages/datos-facturacion"]);
  }
}
